import { TagText } from 'shared/components/Cards';
export const electricityStatusObj = {
	0: TagText.RequestInitiated,
	1: TagText.TokenGenerated,
	2: TagText.PaymentCompleted,
};
